import { useEffect, useRef } from "react";
import { Lines } from "../../components/ui/Lines";
import { Button } from "../../components/ui/Button";

interface Props {
  /** 항목 라벨 — 모달 제목 */
  title: string;
  /** 항목 전문. `{days}` 는 서버가 발행 시점에 이미 치환해서 내려준다 */
  body: string;
  /** "개인정보처리자 {name}" */
  processor: string;
  /** "문의 {contact}" */
  contact: string;
  /** "동의하지 않으면 …" 거부권 안내 */
  refusal: string;
  closeLabel: string;
  onClose: () => void;
}

/**
 * 동의 항목 전문 모달 (BOOTH-66, 스펙 §4.2) — `.view` 안 absolute 오버레이(portal 없음).
 * 종이색 카드 + 스크롤 가능한 전문 + 항목과 무관하게 항상 붙는 footer(처리자·문의·거부권) + "닫기".
 * 모달 안에서는 체크하지 않는다(헷갈림 방지) — 닫기만 있다.
 */
export function ConsentBodyModal({ title, body, processor, contact, refusal, closeLabel, onClose }: Props) {
  const footerRef = useRef<HTMLDivElement>(null);

  // 열리면 닫기 버튼에 포커스 — 보조기기가 모달 안에서 시작하게. Esc 로도 닫힌다
  useEffect(() => {
    footerRef.current?.querySelector("button")?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="consent-modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="consent-modal__card">
        <h2 className="consent-modal__title">{title}</h2>
        <div className="consent-modal__body" tabIndex={0}>
          <Lines text={body} />
        </div>
        <div className="consent-modal__footer" ref={footerRef}>
          <p>{processor}</p>
          <p>{contact}</p>
          <p>{refusal}</p>
          <Button variant="secondary" onClick={onClose}>
            {closeLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
